import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Meldung")
], -1)
const _hoisted_2 = {
  class: "alert d-flex align-items-center p-4 rounded-1 border-0 mb-0",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header-alert-content" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Wichtiger Hinweis zur Infothek"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Dieses Informationsportal dient als Infothek und ist Teil des Projektes „Pilot NatApp“. Das Projekt befindet sich in der Entwicklung. Dargestellte Informationen sind ausschließlich Testdaten, welche zukünftige Szenarien beispielhaft darstellen. Der Zugriff und die Nutzung erfolgen lediglich für Testzwecke im Rahmen des Projektes. Gerne können Sie sich unverbindlich umschauen. ")
], -1)
const _hoisted_4 = { class: "m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalTestSystem = _resolveComponent("ModalTestSystem")!

  return (_openBlock(), _createBlock(_component_ModalTestSystem, { name: "test-system-info" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          "aria-hidden": "true",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.performSearch && _ctx.performSearch(...args))),
          class: "me-2 flycon flycon-top flycon-24 flycon-info text-pine lh-0 align-self-start p-0"
        }, " ­ "),
        _hoisted_3
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-black rounded-pill fw-medium text-white",
          "data-bs-dismiss": "modal",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setModalSession && _ctx.setModalSession(...args)))
        }, " Ich habe den Hinweis zur Kenntnis genommen ")
      ])
    ]),
    _: 1
  }))
}